import React from "react";
import PropTypes from "prop-types";

const ApplicationView = ({ applicants }) => {
  // console.log(applicants)
  return (
    <div className="space-y-6">
      {applicants?.map((applicant, index) => (
        <div
          key={index}
          className="applicant-details border rounded-lg p-6 shadow-sm bg-card"
        >
          <h3 className="text-xl font-semibold text-foreground mb-4">
            {applicant?.candidate?.name}
          </h3>

          <div className="space-y-4">
            {/* Tags Section - Full Width */}
            <div className="w-full flex items-center">
              <h4 className="text-md font-medium text-muted-foreground mb-2 ">Tags:</h4>
              <div className="flex flex-wrap gap-2 ml-2 w-full">
                {applicant?.application_tags?.map((tag) => (
                  <div
                    key={tag?.id}
                    className="bg-muted border border-slate-400 text-foreground px-2 py-1 inline rounded-full text-xs"
                  >
                    {tag?.name}
                  </div>
                ))}
              </div>
            </div>

            {/* Scorecard and Notes Section - Side by Side (50% each) */}
            <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
              {/* Scorecard Section */}
              <div className="border rounded-xl border-slate-300 p-2">
                <div className="flex justify-between max-md:flex-col border-slate-300 border-b-2 mb-1">
                  <h4 className="text-md font-medium text-muted-foreground">
                    Score Card
                  </h4>
                  <span className="font-semibold">
                    {applicant?.total_score?.total_score} /{" "}
                    {applicant?.total_score?.max_possible_score}
                  </span>
                </div>
                <p className="text-foreground">
                  {applicant?.total_score?.score_details?.map((scorecard) => (
                    <div className="flex justify-between">
                      <span>{scorecard?.skill}</span>
                      <span>{scorecard?.score}</span>
                    </div>
                  ))}
                </p>
              </div>

              {/* Notes Section */}
              <div className="border rounded-xl border-slate-300 p-2">
                <h4 className="text-md font-medium text-muted-foreground mb-2">
                  Notes:
                </h4>
                <div className="space-y-4 mb-4">
                  {applicant?.application_notes?.length > 0 ? (
                    applicant?.application_notes.map((note) => (
                      <div
                        key={note.id}
                        className="bg-muted p-3 rounded-lg"
                      >
                        <p className="text-foreground mb-2">{note.comment}</p>
                        <div className="flex items-center justify-between text-sm text-foreground">
                          <span>Current Recruiter</span>
                          <span>{note.created_at}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted-foreground text-sm italic">
                      No notes added yet.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

// ApplicantDetails.propTypes = {
//     applicants: PropTypes.arrayOf(
//         PropTypes.shape({
//             name: PropTypes.string.isRequired,
//             tags: PropTypes.arrayOf(PropTypes.string).isRequired,
//             score: PropTypes.number.isRequired,
//             notes: PropTypes.string,
//         })
//     ).isRequired,
// };

// // Dummy Data for Testing
// const dummyApplicants = [
//     {
//         name: 'John Doe',
//         tags: ['Frontend Developer', 'React', 'JavaScript'],
//         score: 85,
//         notes: 'Strong skills in React and problem-solving.',
//     }
// ];

// // Export component with dummy data for testing
// const ApplicantDetailsWithDummyData = () => <ApplicantDetails applicants={dummyApplicants} />;

export default ApplicationView;
